import React from 'react'

import { DSCInitialState, DSCReducer } from './DSCReducer'

const DSCStateContext = React.createContext()
const DSCDispatchContext = React.createContext()

function DSCProvider({ children }) {
  const [state, dispatch] = React.useReducer(DSCReducer, DSCInitialState)
  return (
    <DSCStateContext.Provider value={state}>
      <DSCDispatchContext.Provider value={dispatch}>{children}</DSCDispatchContext.Provider>
    </DSCStateContext.Provider>
  )
}

function useDSCState() {
  const context = React.useContext(DSCStateContext)
  if (context === undefined) {
    throw new Error('ERROR: useDSCState must be used inside of DSCProvider')
  }
  return context
}

function useDSCDispatch() {
  const context = React.useContext(DSCDispatchContext)
  if (context === undefined) {
    throw new Error('ERROR: useDSCDispatch must be used inside of DSCProvider')
  }
  return context
}

export { DSCProvider, useDSCState, useDSCDispatch }
